import { render, staticRenderFns } from "./NCCampaignsList.vue?vue&type=template&id=002710b0"
import script from "./NCCampaignsList.vue?vue&type=script&lang=js"
export * from "./NCCampaignsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports